import { connect } from 'react-redux'

import * as selectors from './selectors'
import StoreSearchInput from './StoreSearchInput'

const mapStateToProps = (state, ownProps) => ({
  initialStoreName: selectors.initialStoreName(state, ownProps),
})

export default connect(mapStateToProps)(StoreSearchInput)
